import styled from "styled-components";

export const SiteHeaderWrapper = styled.div`
  height: 5vh;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-bottom: 2px solid black;
  width: 100vw;
`;
